/* tslint:disable */
/* eslint-disable */
/**
 * NORA Api
 *  ## Headers  ### X-App-Version  Remember to include the `X-App-Version` header in every request. This will verify that the app version works with this API version. The API will return a `X-Minimum-App-Version` header as well including the minimum app version that is supported by this API. The contents of the header are is a JSON encoded DTO, `VersionHeaderDTO`. 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApiResult } from '../models';
// @ts-ignore
import type { GetDrawLayerFeaturesByTiles200Response } from '../models';
/**
 * DrawLayerApi - axios parameter creator
 */
export const DrawLayerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * List the features intersecting a batch of XYZ (Web Mercator) map tiles for draw layers, leaving out cached tiles that are still up to date
         * @summary List features within map tiles
         * @param {string} operationId 
         * @param {Array<string>} [tiles] XYZ (Web Mercator) tiles as \&quot;&lt;z&gt;/&lt;x&gt;/&lt;y&gt;\&quot; the client has no up-to-date cached features for
         * @param {Array<string>} [cachedTiles] XYZ (Web Mercator) tiles as \&quot;&lt;z&gt;/&lt;x&gt;/&lt;y&gt;\&quot; the client holds cached features for, at its known generations. Together with tiles at most 16 per request
         * @param {Array<string>} [drawLayers] Draw layers as \&quot;&lt;drawLayerId&gt;\&quot;, or \&quot;&lt;drawLayerId&gt;:&lt;generation&gt;\&quot; with the features generation of the client\&#39;s cached tiles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDrawLayerFeaturesByTiles: async (operationId: string, tiles?: Array<string>, cachedTiles?: Array<string>, drawLayers?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'operationId' is not null or undefined
            assertParamExists('getDrawLayerFeaturesByTiles', 'operationId', operationId)
            const localVarPath = `/api/nora/draw-layer/tiles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            if (operationId !== undefined) {
                localVarQueryParameter['operationId'] = operationId;
            }

            if (tiles) {
                localVarQueryParameter['tiles'] = tiles;
            }

            if (cachedTiles) {
                localVarQueryParameter['cachedTiles'] = cachedTiles;
            }

            if (drawLayers) {
                localVarQueryParameter['drawLayers'] = drawLayers;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DrawLayerApi - functional programming interface
 */
export const DrawLayerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DrawLayerApiAxiosParamCreator(configuration)
    return {
        /**
         * List the features intersecting a batch of XYZ (Web Mercator) map tiles for draw layers, leaving out cached tiles that are still up to date
         * @summary List features within map tiles
         * @param {string} operationId 
         * @param {Array<string>} [tiles] XYZ (Web Mercator) tiles as \&quot;&lt;z&gt;/&lt;x&gt;/&lt;y&gt;\&quot; the client has no up-to-date cached features for
         * @param {Array<string>} [cachedTiles] XYZ (Web Mercator) tiles as \&quot;&lt;z&gt;/&lt;x&gt;/&lt;y&gt;\&quot; the client holds cached features for, at its known generations. Together with tiles at most 16 per request
         * @param {Array<string>} [drawLayers] Draw layers as \&quot;&lt;drawLayerId&gt;\&quot;, or \&quot;&lt;drawLayerId&gt;:&lt;generation&gt;\&quot; with the features generation of the client\&#39;s cached tiles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDrawLayerFeaturesByTiles(operationId: string, tiles?: Array<string>, cachedTiles?: Array<string>, drawLayers?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDrawLayerFeaturesByTiles200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDrawLayerFeaturesByTiles(operationId, tiles, cachedTiles, drawLayers, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DrawLayerApi.getDrawLayerFeaturesByTiles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DrawLayerApi - factory interface
 */
export const DrawLayerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DrawLayerApiFp(configuration)
    return {
        /**
         * List the features intersecting a batch of XYZ (Web Mercator) map tiles for draw layers, leaving out cached tiles that are still up to date
         * @summary List features within map tiles
         * @param {DrawLayerApiGetDrawLayerFeaturesByTilesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDrawLayerFeaturesByTiles(requestParameters: DrawLayerApiGetDrawLayerFeaturesByTilesRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetDrawLayerFeaturesByTiles200Response> {
            return localVarFp.getDrawLayerFeaturesByTiles(requestParameters.operationId, requestParameters.tiles, requestParameters.cachedTiles, requestParameters.drawLayers, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getDrawLayerFeaturesByTiles operation in DrawLayerApi.
 */
export interface DrawLayerApiGetDrawLayerFeaturesByTilesRequest {
    readonly operationId: string

    /**
     * XYZ (Web Mercator) tiles as \&quot;&lt;z&gt;/&lt;x&gt;/&lt;y&gt;\&quot; the client has no up-to-date cached features for
     */
    readonly tiles?: Array<string>

    /**
     * XYZ (Web Mercator) tiles as \&quot;&lt;z&gt;/&lt;x&gt;/&lt;y&gt;\&quot; the client holds cached features for, at its known generations. Together with tiles at most 16 per request
     */
    readonly cachedTiles?: Array<string>

    /**
     * Draw layers as \&quot;&lt;drawLayerId&gt;\&quot;, or \&quot;&lt;drawLayerId&gt;:&lt;generation&gt;\&quot; with the features generation of the client\&#39;s cached tiles
     */
    readonly drawLayers?: Array<string>
}

/**
 * DrawLayerApi - object-oriented interface
 */
export class DrawLayerApi extends BaseAPI {
    /**
     * List the features intersecting a batch of XYZ (Web Mercator) map tiles for draw layers, leaving out cached tiles that are still up to date
     * @summary List features within map tiles
     * @param {DrawLayerApiGetDrawLayerFeaturesByTilesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getDrawLayerFeaturesByTiles(requestParameters: DrawLayerApiGetDrawLayerFeaturesByTilesRequest, options?: RawAxiosRequestConfig) {
        return DrawLayerApiFp(this.configuration).getDrawLayerFeaturesByTiles(requestParameters.operationId, requestParameters.tiles, requestParameters.cachedTiles, requestParameters.drawLayers, options).then((request) => request(this.axios, this.basePath));
    }
}

